import HexagonStarSpiral from '@/assets/graphical-elements/hexagon-star-spiral.svg'
import {cn} from '@/lib/utils'
import {type IconProps} from '../types'

export const HexagonStarSpiralIcon = ({className}: IconProps) => <HexagonStarSpiral className={cn('fill-current', className)} />
